import { render, staticRenderFns } from "./Bonus_mond.vue?vue&type=template&id=445b21af&scoped=true&"
import script from "./Bonus_mond.vue?vue&type=script&lang=js&"
export * from "./Bonus_mond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b21af",
  null
  
)

export default component.exports